// extracted by mini-css-extract-plugin
export default {"menuBlock":"kE-z","title":"lE-z","nav":"mE-z","flexCell":"nE-z","facetLink":"oE-z"};